import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { defaultFormValues } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { selectLocationOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface LocationsSegmentedControlProps {
  name: string;
  id: string;
}

export function LocationsSegmentedControl({
  name,
  id,
}: LocationsSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      width="100%"
      id={id}
      control={control}
      label="Select location"
      name={name}
      defaultValue={defaultFormValues.locationsExistence}
      options={selectLocationOptions}
    />
  );
}
